/**
 * 鲍氏商城 - 系统常量 - 用户自定义
 * http://menger.me
 * @大梦
 */

'use strict';

export default {

    /**
     * @微信相关
     */
    // 微信客服
    WECHAT_CUSTOMER_SERVICES: 'https://work.weixin.qq.com/kfid/kfc915c4af65a6ce17f',

    /**
     * @支付类型
     */
    WECHAT: 'weixin',
    WECHAT_CODE: 1,
    ALIPAY: 'alipay',
    ALIPAY_CODE: 2,
    YUE: 'yue',
    YUE_CODE: 3,
};